import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { QueryClientProvider } from "@tanstack/react-query"
import { queryClient } from "./queryClient"
import { initSentry } from "./lib/sentry"
import { initOpenTelemetry } from "./lib/otel"
import { reportWebVitals } from "./lib/webVitals"
import App from "./App"
import "./index.css"

// Initialize observability before rendering so all network
// requests and errors are captured from the start.
initSentry()
initOpenTelemetry()

createRoot(document.querySelector("#root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
)

// Report Core Web Vitals after hydration
reportWebVitals()
